import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Sql"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 15.75V6.75H16.5V17.25H22.5V15.75H18ZM13.5 6.75H10.5C9.67157 6.75 9 7.42157 9 8.25V15.75C9 16.5784 9.67157 17.25 10.5 17.25H11.25V18.75C11.25 19.5784 11.9216 20.25 12.75 20.25H14.25V18.75H12.75V17.25H13.5C14.3284 17.25 15 16.5784 15 15.75V8.25C15 7.42157 14.3284 6.75 13.5 6.75ZM10.5 15.75V8.25H13.5V15.75H10.5ZM6 17.25H1.5V15.75H6V12.75H3C2.17157 12.75 1.5 12.0784 1.5 11.25V8.25C1.5 7.42157 2.17157 6.75 3 6.75H7.5V8.25H3V11.25H6C6.82843 11.25 7.5 11.9216 7.5 12.75V15.75C7.5 16.5784 6.82843 17.25 6 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Sql.vue"]]);
